import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
function RecentActivityList() {
  return ___EmotionJSX("div", null, ___EmotionJSX("p", null, "Recent Activitiy List"));
}
export default RecentActivityList;